import posthog from 'posthog-js'

let initialized = false

export function initAnalytics() {
  if (initialized) return
  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) {
    if (import.meta.env.DEV) {
      console.info('[analytics] VITE_POSTHOG_KEY not set — PostHog disabled')
    }
    return
  }
  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
  })
  initialized = true
}

export function identifyUser(user) {
  if (!initialized || !user?.id) return
  posthog.identify(user.id, {
    email: user.email,
    role: user.role,
  })
}

export function resetAnalytics() {
  if (!initialized) return
  posthog.reset()
}

export function track(event, props = {}) {
  if (!initialized) return
  posthog.capture(event, props)
}
